import { useAppDispatch, useAppSelector } from '../../store'
import { toggleSidebar } from '../../store/slices/appSlice'
import { Menu, User } from 'lucide-react'
import { motion } from 'framer-motion'
import { useTranslation } from '../../hooks/useTranslation'
import { useDesignSystem } from '@/hooks/useDesignSystem'
import { NotificationBell } from '../ui/notification-bell'

export function Header() {
  const dispatch = useAppDispatch()
  const user = useAppSelector((s) => s.auth.user)
  const { t } = useTranslation()
  const { animations, patterns } = useDesignSystem()

  return (
    <header className={'sticky top-0 z-30 flex h-16 items-center justify-between border-b border-border backdrop-blur-sm px-4 lg:px-6 shadow-sm ' + patterns.glass}>
      <div className="flex items-center gap-4">
        <motion.button
          variants={animations.component.buttonPress}
          initial="rest"
          whileHover="hover"
          whileTap="tap"
          onClick={() => dispatch(toggleSidebar())}
          className={patterns.utils.cx(
            'flex items-center justify-center h-9 w-9 transition-colors lg:hidden touch-target',
            patterns.radius.xl,
            'bg-secondary text-secondary-foreground hover:bg-primary hover:text-primary-foreground'
          )}
          style={{ minHeight: '44px', minWidth: '44px' }}
        >
          <Menu size={20} />
        </motion.button>

        <div className="hidden lg:block">
          <h2 className={'text-lg font-semibold ' + patterns.text.heading}>
            {user?.name ? t('pages.dashboard.welcome', { name: user.name }) : t('pages.dashboard.welcome', { name: '' })}
          </h2>
        </div>
      </div>

      <div className="flex items-center gap-3">
        {/* Notifications */}
        <NotificationBell />

        {/* User info */}
        {user && (
          <div className={'hidden sm:flex items-center gap-2 px-3 py-1.5 ' + patterns.utils.cx(patterns.radius.xl, 'bg-muted')}>
            <div className={patterns.utils.cx('h-6 w-6 flex items-center justify-center', patterns.radius.full, 'bg-gradient-to-br from-primary-800 to-primary text-primary-100')}>
              <User size={12} />
            </div>
            <span className={'text-sm font-medium ' + patterns.text.heading}>
              {user.name || t('common.user')}
            </span>
          </div>
        )}
      </div>
    </header>
  )
}
